import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Grid, LinearProgress, Paper, Typography } from '@mui/material';
import userLogout from 'redux/actions/userLogout';
import isLoggedIn from 'global/utils/isLoggedIn';

const logoutGridSx = {
  m: 2,
  justifyContent: 'center',
};

const logoutLoadingPaperSx = {
  p: 3,
  backgroundColor: 'secondary.main',
  color: 'white',
  textAlign: 'center',
};

const logoutLoadingPaperProgressSx = {
  my: 3,
};

export default function Logout() {
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));
  const dispatch = useDispatch();

  const renderRedirect = (redirect) => {
    if (!redirect) {
      return <Redirect to="/" />;
    }
  };

  useEffect(() => {
    if (loggedIn === true) {
      dispatch(userLogout());
    }
  }, []);

  return (
    <Grid justifyContent="center" alignItems="center" container sx={logoutGridSx}>
      <Grid item xs={10} lg={6}>
        <Paper sx={logoutLoadingPaperSx}>
          {renderRedirect(loggedIn)}
          <Typography component="h1" variant="h5">
            Bye Bye!
          </Typography>
          <LinearProgress color="secondary" sx={logoutLoadingPaperProgressSx} />
          <Typography variant="subtitle1">Hang on, we're erasing your footsteps and sweeping away the breadcrumbs.</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
